import { LinearProgress } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useState, useCallback } from 'react';
import { ApiRequestIdentifier, ApiResponseIdentifier } from '../services/api/base';

const pendingRequestQueue: boolean[] = [];

const GlobalLoadingBar: FunctionComponent = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const refreshLoading = () => {
    const isLoading = pendingRequestQueue.reduce((acc, cur) => acc || cur, false);
    setLoading(isLoading);
  };

  const onRequestOutgoing = useCallback(() => {
    pendingRequestQueue.unshift(true);
    refreshLoading();
  }, []);

  const onResponseIncoming = useCallback(() => {
    pendingRequestQueue.pop();
    refreshLoading();
  }, []);

  // FIXME: a global event listener must be added in a single source of truth.
  useEffect(() => {
    window.addEventListener(ApiRequestIdentifier, onRequestOutgoing);
    window.addEventListener(ApiResponseIdentifier, onResponseIncoming);

    return () => {
      window.removeEventListener(ApiRequestIdentifier, onRequestOutgoing);
      window.removeEventListener(ApiResponseIdentifier, onResponseIncoming);
    };
  }, [onRequestOutgoing, onResponseIncoming]);

  return <LinearProgress color="secondary" style={{ display: loading ? 'block' : 'none', zIndex: 2000, position: 'fixed', width: '100%' }} />;
};

export default GlobalLoadingBar;
